import React from "react";
import FeedIcon from "@mui/icons-material/Feed";
const FormMakerIcon = () => {
  return <FeedIcon sx={{ fill: "white" }} />;
};

export default FormMakerIcon;
